var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoAlbum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_91",
    "data-name": "Group 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.644,
    height: 74.297,
    viewBox: "0 0 77.644 74.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "photo-album-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 77.644,
    height: 74.297,
    fill: "#3e3e3e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    clipPath: "url(#photo-album-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M51.9,161.686H9.672A9.672,9.672,0,0,0,0,171.358v42.225a9.672,9.672,0,0,0,9.672,9.672H51.9a9.672,9.672,0,0,0,9.672-9.672V171.358a9.672,9.672,0,0,0-9.672-9.672m6.481,35.926L45.9,186.147a2.127,2.127,0,0,0-2.877,0L26.531,201.294l-8.215-7.546a2.127,2.127,0,0,0-2.877,0L3.191,205v-33.64a6.481,6.481,0,0,1,6.481-6.481H51.9a6.481,6.481,0,0,1,6.481,6.481Z",
    transform: "translate(0 -148.958)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M145.037,294.568a7.27,7.27,0,1,0,7.27,7.27,7.278,7.278,0,0,0-7.27-7.27",
    transform: "translate(-126.922 -271.379)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M265.752,8.527,224.357.192a9.672,9.672,0,0,0-11.391,7.572l-.357,1.775h36.356A12.876,12.876,0,0,1,261.826,22.4V64.625a12.892,12.892,0,0,1-.2,2.268,9.631,9.631,0,0,0,3.362-5.581l8.336-41.394a9.672,9.672,0,0,0-7.572-11.391",
    transform: "translate(-195.872 0.001)",
    fill: "#3e3e3e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoAlbum);
export default __webpack_public_path__ + "static/media/photo-album.169697e63eb9d078d306cd48bd0a35d0.svg";
export { ForwardRef as ReactComponent };